import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  addToutAndPackage,
  categoriesList,
  fetchGalleryImageUpdate,
  fetchpackageDeginationsList,
  getPackageData,
  packageDeginationsList,
  updatePackages,
} from "../../services/userservice";
import { Modal, Button, Alert } from "react-bootstrap";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useDispatch, useSelector } from "react-redux";

import {
  setLoading as setCategoriesLoading,
  setConfigurations,
  deleteConfiguration,
  setError,
  setCategories,
} from "../../features/common/categorySlice";
import imageConfig from "../../config/imageConfig";

const TourAndPackages = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [packageData, setPackageData] = useState({});

  const [formData, setFormData] = useState({
    package_name: "",
    package_country: "",
    package_destination: "",
    package_type: "",
    package_category: null,
    package_hotel_details: "",
    package_validity: "",
    package_categories: [],
    package_inclusions: "",
    package_exclusions: "",
    package_validity: new Date().toISOString().split("T")[0],
    package_description: "",
    package_price: "",
    package_price_details: "",
    package_how_to_book: "",
    package_duration: "",
    package_gallery: [],
    package_hotel: false,
    package_transport: false,
    package_meal: false,
    package_sightseeing: "",
    status: "",
    meta_title: "",
    meta_description: "",
    meta_keyword: "",
    itineraries: [],
  });
  const dropdownRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value, multiple, options, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked,
      }));
    } else if (multiple) {
      const selectedValues = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: selectedValues,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));

      if (name === "package_duration") {
        const duration = parseInt(value, 10) || 0;

        setItineraries((prevItineraries) => {
          const updatedItineraries = prevItineraries?.slice(0, duration);
          if (duration > prevItineraries.length) {
            const newItineraries = Array.from(
              { length: duration - prevItineraries.length },
              (_, index) => ({
                package_day_no: prevItineraries.length + index + 1,
                package_itinerary: "",
                package_photo: "",
                is_meal: false,
                is_breakfast: false,
                is_lunch: false,
                is_dinner: false,
              })
            );
            return [...updatedItineraries, ...newItineraries];
          }

          return updatedItineraries;
        });
      }
    }
  };

  const [imageURL, setImageURL] = useState(formData?.package_gallery);

  useEffect(() => {
    if (Array.isArray(formData.package_gallery)) {
      setImageURL(formData.package_gallery);
    }
  }, [formData.package_gallery]);

  const [itineraries, setItineraries] = useState([
    {
      package_day_no: 1,
      package_itinerary: "",
      package_photo: "",
      is_meal: "",
      is_breakfast: "",
      is_lunch: "",
      is_dinner: "",
    },
  ]);

  console.log("itineraries", itineraries);
  const [imageURLsItinerary, setImageURLsItinerary] = useState({});
  const handleFileChange = async (index, e) => {
    const files = Array.from(e.target.files);
    const oversizedFiles = files.filter(file => file.size > 1 * 1024 * 1024);
    if (oversizedFiles.length > 0) {
      alert("Each file must be less than or equal to 1MB.");
      e.target.value = ""; // reset input
      return;
    }
    const formData = new FormData();

    files.forEach((file) => {
      formData.append("profile_pic", file);
      formData.append("type", "gallery");
    });

    try {
      const response = await fetchGalleryImageUpdate(formData);
      const imageUrl = response?.data?.files[0]?.image_url;
      const base_url = response?.data?.files[0]?.base_url;
      console.log("imageUrl", base_url+imageUrl);

      if (imageUrl) {
        const updatedItineraries = itineraries.map((itinerary, i) =>
          i === index
            ? {
                ...itinerary,
                package_photo: imageUrl,
                is_breakfast:
                  itinerary?.is_breakfast != "" ? itinerary?.is_breakfast : 0,
                is_dinner:
                  itinerary?.is_dinner != "" ? itinerary?.is_dinner : 0,
                is_lunch: itinerary?.is_lunch != "" ? itinerary?.is_lunch : 0,
                is_meal: itinerary?.is_meal != "" ? itinerary?.is_meal : 0,
              }
            : {
                ...itinerary,
                is_breakfast:
                  itinerary?.is_breakfast != "" ? itinerary?.is_breakfast : 0,
                is_dinner:
                  itinerary?.is_dinner != "" ? itinerary?.is_dinner : 0,
                is_lunch: itinerary?.is_lunch != "" ? itinerary?.is_lunch : 0,
                is_meal: itinerary?.is_meal != "" ? itinerary?.is_meal : 0,
              }
        );
        setItineraries(updatedItineraries);
        console.log("updatedItineraries", updatedItineraries);
        setImageURLsItinerary((prev) => ({
          ...prev,
          [index]: [imageUrl?.startsWith('https')? imageUrl
            : imageUrl
            ? base_url + imageUrl: ''],
        }));

        console.log("Image upload successful:", imageUrl);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const formDataToSend = {
        ...formData,
        itineraries: itineraries.map((itinerary) => ({
          package_day_no: itinerary?.package_day_no,
          package_itinerary: itinerary?.package_itinerary,
          package_photo: itinerary?.package_photo || "",
          is_meal: itinerary?.is_meal || 0,
          is_breakfast: itinerary?.is_breakfast || 0,
          is_lunch: itinerary?.is_lunch || 0,
          is_dinner: itinerary?.is_dinner || 0,
        })),
        package_gallery: imageURL || "",
      };

      console.log("Sending data: ", formDataToSend);
      const response =
        id && id !== "add"
          ? await updatePackages(id, formDataToSend)
          : await await addToutAndPackage(formDataToSend);

      setShowModal(true);
      setTimeout(() => {
        navigate("/package-list");
        setShowModal(false);
      }, 2000);
    } catch (error) {
      setError(error.message || "An error occurred while submitting the form.");
    } finally {
      setLoading(false);
    }
  };
  const [isUploading, setIsUploading] = useState(false);

  const handleGalleryChange = async (e) => {
    const files = Array.from(e.target.files);
    const oversizedFiles = files.filter(file => file.size > 1 * 1024 * 1024);
    
    
    if (oversizedFiles.length > 0) {
      alert("Each file must be less than or equal to 1MB.");
      e.target.value = ""; // reset file input
      return;
    }
    const formData = new FormData();

    files.forEach((file) => {
      formData.append("profile_pic", file);
      formData.append("type", "gallery");
    });
    setIsUploading(true);
    try {
      const response = await fetchGalleryImageUpdate(formData);
      setImageURL(response?.data?.files);
      console.log("Image upload successful:", response?.data?.files);
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setIsUploading(false);
    }
  };

  const generateMetaTags = () => {
    const title = `${formData.package_name}, ${formData.package_categories} ${formData.package_type}, ${formData.package_destination}`;
    const plainTextInclusions = formData.package_inclusions.replace(
      /<[^>]*>?/gm,
      ""
    );
    let description = `${formData.package_name} ${formData.package_categories} - ${plainTextInclusions}`;
    description =
      description.length > 160 ? description.slice(0, 160) + "." : description;
    const keywords = `${formData.package_name}, ${formData.package_categories} ${formData.package_type}, ${formData.package_destination}, ${formData.package_type} ${formData.package_categories} ${formData.package_destination}`;
    setFormData((prevData) => ({
      ...prevData,
      meta_title: title,
      meta_description: description,
      meta_keyword: keywords,
    }));
  };

  useEffect(() => {
    if (id && id !== "add" && packageData !== id) {
      setPackageData(id);
      fetchPackageData(id);
    }
  }, [id, packageData]);

  const fetchPackageData = async (id) => {
    try {
      setLoading(true);
      const response = await getPackageData(id);
      if (response) {
        setFormData({
          package_name: response.package_name || "",
          package_country: response.package_country || "",
          package_destination: response.package_destination || "",
          package_type: response.package_type || "",
          package_categories:
            response.package_categories.map((cat) => cat.id) || [],
          package_inclusions: response.package_inclusions || "",
          package_validity: response.package_validity || "",
          package_hotel_details: response.package_hotel_details || "",
          package_exclusions: response.package_exclusions || "",
          package_validity: response.package_validity || "",
          package_price: response.package_price || "",
          package_price_details: response.package_price_details || "",
          package_how_to_book: response.package_how_to_book || "",
          package_duration: response.package_duration || "",
          package_gallery: response.package_gallery || [],
          package_hotel: response.package_hotel || 0,
          package_transport: response.package_transport || 0,
          package_meal: response.package_meal || 0,
          package_description: response.package_description || "",
          package_sightseeing: response.package_sightseeing || "",
          status: response.status || "active",
          meta_title: response.meta_title || "",
          meta_description: response.meta_description || "",
          meta_keyword: response.meta_keyword || "",
          itineraries: response.itineraries || [],
        });

        const initialImageURLs = response.itineraries.reduce((acc, itinerary, index) => {
            const photo = itinerary?.package_photo;
            acc[index] = photo
              ? [photo.startsWith('https') ? photo : imageConfig.GALLERY_IMAGE_URL + photo]
              : [];
            return acc;
          }, {});
        setImageURLsItinerary(initialImageURLs);
        console.log("initialImageURLs", initialImageURLs);
        setItineraries(response.itineraries || []);
      }
      setLoading(false);
    } catch (error) {
      setError(
        error.message || "An error occurred while fetching package data."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => setShowModal(false);

  const handleMealCheckboxChange = (index, field) => {
    setItineraries((prevItineraries) =>
      prevItineraries.map((itinerary, i) =>
        i === index ? { ...itinerary, [field]: !itinerary[field] } : itinerary
      )
    );
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const { categories } = useSelector((state) => state?.category);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(setCategoriesLoading());
        const response = await categoriesList();
        dispatch(setCategories(response));
      } catch (error) {
        dispatch(setError(error.message));
      }
    };
    fetchData();
  }, [dispatch]);

  const selectedCategoryNames =
    formData.package_categories
      .map((id) => categories.find((category) => category.id === id)?.name)
      .filter(Boolean)
      .join(", ") || "Select Categories";

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    const selectedId = parseInt(value);

    setFormData((prevFormData) => {
      const updatedCategories = checked
        ? [...prevFormData.package_categories, selectedId] // Add ID if checked
        : prevFormData.package_categories.filter((id) => id !== selectedId); // Remove ID if unchecked

      return { ...prevFormData, package_categories: updatedCategories };
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [packageDesignations, setPackageDesignations] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchpackageDeginationsList();
        setPackageDesignations(response?.data);
      } catch (error) {
        console.log("Error fetching package designations:", error);
      }
    };

    fetchData();
  }, []);
  const dateInputRef = useRef(null);

  const handleClick = () => {
    dateInputRef.current?.showPicker();
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Manage Packages </h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">Manage Packages</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              {/* {error && <div className="alert alert-danger">{error}</div>} */}

              {error && (
                <Alert
                  variant="danger"
                  style={{
                    position: "fixed",
                    top: "8px",
                    left: "0",
                    right: "0",
                    zIndex: "1050",
                    width: "50%",
                    margin: "auto",
                    textAlign: "center",
                  }}
                >
                  {error}
                </Alert>
              )}

              <form onSubmit={handleSubmit}>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Package Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="package_name"
                            value={formData.package_name}
                            onChange={handleInputChange}
                            placeholder="Enter Package Name"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Package Category</label>
                          <div
                            className="custom-dropdown-container"
                            ref={dropdownRef}
                          >
                            <div
                              className="custom-dropdown"
                              onClick={toggleDropdown}
                            >
                              <input
                                type="text"
                                className="dropdown-input"
                                value={selectedCategoryNames}
                                readOnly
                                placeholder="Select Categories"
                              />
                              <span className="arrow">
                                {isOpen ? "▲" : "▼"}
                              </span>
                            </div>

                            {isOpen && (
                              <div className="dropdown-options">
                                {categories.map((option) => (
                                  <div
                                    key={option.id}
                                    className="checkbox-container"
                                  >
                                    <input
                                      type="checkbox"
                                      id={`category-${option.id}`}
                                      value={option.id}
                                      checked={formData?.package_categories?.includes(
                                        option.id
                                      )}
                                      onChange={handleCheckboxChange}
                                    />
                                    <label htmlFor={`category-${option.id}`}>
                                      {option.name}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Package Type</label>
                          <select
                            className="form-control"
                            name="package_type"
                            value={formData.package_type}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select</option>
                            <option value="Domestic">Domestic</option>
                            <option value="International">International</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Package Country</label>
                          <input
                            type="text"
                            className="form-control"
                            name="package_country"
                            value={formData.package_country}
                            onChange={handleInputChange}
                            placeholder="Enter Package Country"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Package Destination</label>
                          <select
                            className="form-control"
                            name="package_destination"
                            value={formData.package_destination}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select</option>
                            {packageDesignations?.map((item, i) => (
                              <option key={i} value={item?.name}>
                                {item?.name?.charAt(0).toUpperCase() +
                                  item?.name?.slice(1)?.toLowerCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Package Price</label>
                          <input
                            type="text"
                            className="form-control"
                            name="package_price"
                            value={formData.package_price}
                            onChange={handleInputChange}
                            placeholder="Enter Package Price"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Package Validity</label>
                          <input
                            type="Date"
                            className="form-control"
                            name="package_validity"
                            value={formData.package_validity}
                            onChange={handleInputChange}
                            placeholder="Enter Package Validity"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Package Price Details</label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={formData.package_price_details}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setFormData((prev) => ({
                                ...prev,
                                package_price_details: data,
                              }));
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Package Hotel Details</label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={formData.package_hotel_details}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setFormData((prev) => ({
                                ...prev,
                                package_hotel_details: data,
                              }));
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Sightseeing</label>
                          <input
                            type="text"
                            className="form-control"
                            name="package_sightseeing"
                            value={formData.package_sightseeing}
                            onChange={handleInputChange}
                            placeholder="Enter Sightseeing Information"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Package Description</label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={formData.package_description}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setFormData((prev) => ({
                                ...prev,
                                package_description: data,
                              }));
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Package How To Book</label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={formData.package_how_to_book}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setFormData((prev) => ({
                                ...prev,
                                package_how_to_book: data,
                              }));
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Package Inclusions</label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={formData.package_inclusions}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setFormData((prev) => ({
                                ...prev,
                                package_inclusions: data,
                              }));
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Package Exclusions</label>
                          <CKEditor
                            editor={ClassicEditor}
                            data={formData.package_exclusions}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setFormData((prev) => ({
                                ...prev,
                                package_exclusions: data,
                              }));
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>
                            <input
                              type="checkbox"
                              name="package_hotel"
                              checked={formData.package_hotel}
                              onChange={handleInputChange}
                              className="mx-2"
                            />
                            Hotel
                          </label>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>
                            <input
                              type="checkbox"
                              name="package_transport"
                              checked={formData.package_transport}
                              onChange={handleInputChange}
                              className="mx-2"
                            />
                            Transport
                          </label>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>
                            <input
                              type="checkbox"
                              name="package_meal"
                              checked={formData.package_meal}
                              onChange={handleInputChange}
                              className="mx-2"
                            />
                            Meal
                          </label>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Package Duration (Days)</label>
                          <select
                            className="form-control"
                            name="package_duration"
                            value={formData?.package_duration}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Itineraries</label>
                          {itineraries.map((itinerary, index) => (
                            <div key={index} className="itinerary-section mb-2">
                              <label>Day {itinerary?.package_day_no}</label>
                              <div className="row">
                                <div className="col-sm-6 my-2">
                                  <div className="checkbox-grid">
                                    <label className="checkbox-item">
                                      <input
                                        type="checkbox"
                                        className="mx-2"
                                        checked={itinerary.is_meal}
                                        onChange={() =>
                                          handleMealCheckboxChange(
                                            index,
                                            "is_meal"
                                          )
                                        }
                                      />
                                      MEAL
                                    </label>
                                    <label className="checkbox-item">
                                      <input
                                        type="checkbox"
                                        className="mx-2"
                                        checked={itinerary.is_breakfast}
                                        onChange={() =>
                                          handleMealCheckboxChange(
                                            index,
                                            "is_breakfast"
                                          )
                                        }
                                      />
                                      BREAKFAST
                                    </label>

                                    <label className="checkbox-item">
                                      <input
                                        type="checkbox"
                                        className="mx-2"
                                        checked={itinerary.is_lunch}
                                        onChange={() =>
                                          handleMealCheckboxChange(
                                            index,
                                            "is_lunch"
                                          )
                                        }
                                      />
                                      LUNCH
                                    </label>
                                    <label className="checkbox-item">
                                      <input
                                        type="checkbox"
                                        className="mx-2"
                                        checked={itinerary.is_dinner}
                                        onChange={() =>
                                          handleMealCheckboxChange(
                                            index,
                                            "is_dinner"
                                          )
                                        }
                                      />
                                      DINNER
                                    </label>
                                  </div>
                                </div>

                                <div className="col-sm-6 mb-3">
                                  <input
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => handleFileChange(index, e)}
                                  />
                                </div>

                                <div className="col-sm-12">
                                  {imageURLsItinerary[index] &&
                                    imageURLsItinerary[index].map(
                                      (img, imgIndex) => (
                                        <div
                                          className="col-sm-3 py-3"
                                          key={imgIndex}
                                        >
                                          <img
                                            src={img.image_url || img}
                                            alt={`Gallery ${imgIndex}`}
                                            style={{ width: "100%" }}
                                          />
                                        </div>
                                      )
                                    )}
                                </div>

                                <div className="col-sm-12">
                                  <CKEditor
                                    editor={ClassicEditor}
                                    data={itinerary.package_itinerary}
                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      setItineraries((prevItineraries) =>
                                        prevItineraries.map((it, i) =>
                                          i === index
                                            ? { ...it, package_itinerary: data }
                                            : it
                                        )
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>Package Gallery (Upload Images)</label>
                          <input
                            type="file"
                            multiple
                            className="form-control"
                            onChange={handleGalleryChange}
                          />
                        </div>
                        {isUploading && (
                          <div
                            className="d-flex align-items-center"
                            style={{ gap: "8px" }}
                          >
                            <div className="custom-spinner"></div>
                            <span style={{ color: "blue", fontWeight: "bold" }}>
                              Please wait, uploading...
                            </span>
                          </div>
                        )}
                      </div>
                      {!isUploading && (
                        <div className="form-group">
                          <div className="row">
                            {imageURL && imageURL.length > 0 ? (
                              <>
                                <label>Uploaded Gallery</label>
                                <br />
                                <div className="row">
                                  {imageURL.map((img, index) => (
                                    <div className="col-sm-3" key={index}>
                                      <img
                                        src={img.image_url?.startsWith('https')? img.image_url
                                            : (img?.image_url
                                            ? imageConfig.GALLERY_IMAGE_URL + img?.image_url: '')}
                                        alt={`Gallery ${index}`}
                                        style={{ width: "100%" }}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </>
                            ) : null}
                          </div>
                        </div>
                      )}

                      <div className="col-sm-12 mb-4">
                        <button
                          type="button"
                          onClick={generateMetaTags}
                          className="btn btn-success mt-2"
                        >
                          Generate Meta Tags
                        </button>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Meta Title</label>
                          <input
                            type="text"
                            className="form-control"
                            name="meta_title"
                            value={formData.meta_title}
                            onChange={handleInputChange}
                            placeholder="Enter Meta Title"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Meta Keyword</label>
                          <input
                            type="text"
                            className="form-control"
                            name="meta_keyword"
                            value={formData.meta_keyword}
                            onChange={handleInputChange}
                            placeholder="Enter Meta Keyword"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Meta Description</label>
                          <input
                            type="text"
                            className="form-control"
                            name="meta_description"
                            value={formData.meta_description}
                            onChange={handleInputChange}
                            placeholder="Enter Meta Description"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Status</label>
                          <select
                            className="form-control"
                            name="status"
                            value={formData.status}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Save Package" : "Save Package"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fa fa-check-circle text-success"></i>
            Success
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <i
              className="fa fa-check-circle text-success mb-4"
              style={{ fontSize: "4rem" }}
            ></i>
            <h4>Your package has been successfully submitted!</h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TourAndPackages;
